<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="12" lg="12" sm="12">
        <v-row>
          <v-col
            :class="!$vuetify.breakpoint.smAndUp ? 'pb-1' : ''"
            cols="12"
            md="6"
            lg="6"
            sm="6"
          >
            <v-subheader class="display-1 font-weight-bold"
              >AMS center and visit allocation</v-subheader
            >
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="6"
            sm="6"
            :class="!$vuetify.breakpoint.smAndUp ? 'py-1' : ''"
          >
            <v-card-actions
              class="d-flex"
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'justify-end'
                  : 'justify-left mt-4'
              "
            >
              <v-btn
                color="#5d58ef"
                class="mr-4 white--text"
                dense
                small
                :to="{ name: 'amsVisitSchedule' }"
              >
                AMS Schedule Visit
              </v-btn>
              <router-link slot="right" :to="{ name: 'amsDashboard' }">
                <v-btn
                  v-if="$vuetify.breakpoint.smAndUp"
                  elevation="1"
                  right
                  small
                  top
                >
                  <v-icon left>mdi-arrow-left</v-icon>back</v-btn
                >
                <v-btn
                  v-else
                  fixed
                  right
                  fab
                  small
                  color="grey lighten-2"
                  elevation="1"
                  class="mr-n2 mt-n12"
                  style="opacity: 0.6"
                >
                  <v-icon>mdi-arrow-left</v-icon></v-btn
                >
              </router-link>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="12" lg="12" sm="12">
        <v-tabs
          next-icon="mdi-chevron-right"
          prev-icon="mdi-chevron-left"
          show-arrows
          v-model="tab"
        >
          <v-tab
            v-for="zone in zoneArray"
            :key="zone.id"
            @click="getZoneDetails(zone.id)"
            :to="{
              name: 'amsCenterAllocation',
              params: { selectedZoneId: zone.id }
            }"
          >
            {{ zone.name }}
          </v-tab>
        </v-tabs>
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4" lg="4" sm="6">
                <v-card elevation="0">
                  <v-card class="d-flex" elevation="0">
                    <v-card class="pa-2" elevation="0">
                      <strong>ZM:</strong> {{ zonalManager }}
                    </v-card>
                  </v-card>
                  <v-card elevation="0">
                    <div
                      class="custom-chip unallocated-border mt-1 mr-2"
                      :class="!$vuetify.breakpoint.smAndUp ? 'pl-2' : 'pl-1'"
                    >
                      <span
                        class="text-caption float-left mt-2 font-weight-bold"
                        >Unallocated:
                      </span>
                      <span
                        class="custom-avatar float-right mr-1 font-weight-medium subtitle-1 red darken-3"
                        >{{ unAllocated }}</span
                      >
                    </div>
                    <div
                      class="custom-chip allocated-border mt-1"
                      :class="!$vuetify.breakpoint.smAndUp ? 'pl-2' : 'pl-1'"
                    >
                      <span
                        class="text-caption float-left mt-2 font-weight-bold"
                        >Allocated:
                      </span>
                      <span
                        class="custom-avatar float-right mr-1 font-weight-medium subtitle-1 green darken-3"
                        >{{ allocated }}</span
                      >
                    </div>
                  </v-card>
                </v-card>
              </v-col>
              <v-col
                cols="12"
                md="4"
                lg="4"
                sm="6"
                xs="12"
                class="d-flex"
                :class="
                  !$vuetify.breakpoint.smAndUp
                    ? 'justify-space-between'
                    : 'justify-center'
                "
              >
                <div class="text-center mr-1">
                  <div class="text-caption font-weight-bold">H</div>
                  <v-avatar color="red darken-3" size="35">
                    <span class="white--text font-weight-medium subtitle-1">{{
                      highPriorityCount
                    }}</span>
                  </v-avatar>
                </div>
                <div class="text-center mr-1">
                  <div class="text-caption font-weight-bold">M</div>
                  <v-avatar color="orange darken-3" size="35">
                    <span class="white--text font-weight-medium subtitle-1">{{
                      mediumPriorityCount
                    }}</span>
                  </v-avatar>
                </div>
                <div class="text-center mr-1">
                  <div class="text-caption font-weight-bold">L</div>
                  <v-avatar color="green darken-3" size="35">
                    <span class="white--text font-weight-medium subtitle-1">{{
                      lowPriorityCount
                    }}</span>
                  </v-avatar>
                </div>
              </v-col>
              <v-col cols="12" md="4" lg="4" sm="12" xs="12">
                <div
                  class="d-flex"
                  :class="$vuetify.breakpoint.smAndUp ? 'justify-end' : 'mt-2'"
                >
                  <v-btn-toggle v-model="singleBtnToggle" mandatory>
                    <v-btn>
                      <v-icon>mdi-format-list-bulleted</v-icon>
                    </v-btn>
                    <v-btn>
                      <v-icon>mdi-calendar</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </v-col>
              <v-col class="py-0" cols="12" md="12" lg="12" sm="12" xs="12">
                <v-card class="d-flex justify-end" elevation="0">
                  <a
                    v-if="zoneAcademicCalendar"
                    class="mr-2 mt-4 text-decoration-underline black--text"
                    :href="zoneAcademicCalendar"
                    target="_blank"
                  >
                    View Academic Calender
                  </a>
                </v-card>
              </v-col>
              <v-col v-show="!amsListView" cols="12" md="12" lg="12" sm="12">
                <amscalenderview
                  :zoneId="parseInt(selectedZoneId)"
                  :amsArray="amsArray"
                  :franchisee="franchiseeList"
                ></amscalenderview>
              </v-col>
              <v-col v-show="amsListView" cols="12" md="10" lg="10" sm="10">
                <v-row>
                  <v-col cols="12" md="4" lg="4" sm="6" xs="12">
                    <v-combobox
                      label="Select AMS"
                      v-model="selectedAms"
                      :items="amsArray"
                      dense
                      item-value="id"
                      item-text="name"
                      @input="
                        resetSearchData('searchAms'),
                          filterAcademicData('searchAms')
                      "
                      clearable
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    lg="4"
                    offset-md="4"
                    offset-lg="4"
                    sm="6"
                    xs="12"
                  >
                    <v-combobox
                      label="Select Center"
                      v-model="selectedFranchisee"
                      :items="franchiseeList"
                      dense
                      item-value="id"
                      item-text="companyName"
                      @input="
                        resetSearchData('searchCenter'),
                          filterAcademicData('searchCenter')
                      "
                      clearable
                      multiple
                    >
                      <template v-slot:item="{ item }">
                        <v-icon
                          x-small
                          :color="
                            item.allocated ? 'green darken-3' : 'red darken-3'
                          "
                          >mdi-checkbox-blank-circle</v-icon
                        >
                        <span class="ml-4">{{ item.companyName }}</span>
                      </template>
                    </v-combobox>
                  </v-col>
                </v-row>
                <div class="custom-table-layout">
                  <div class="days-column">
                    <div class="days-header font-weight-medium pa-2">Days</div>
                    <div class="days-text pa-2" v-for="i in dayLength" :key="i">
                      {{ i }}
                    </div>
                  </div>
                  <div
                    v-for="(item, index) in academicManger"
                    :key="index"
                    class="am-column"
                  >
                    <div class="am-header font-weight-medium pa-2">
                      {{ item.amName }}
                    </div>
                    <draganddrop
                      :item="item.allocatedFranchisees"
                      :index="index"
                      :amId="item.amID"
                      :totalDays="dayLength"
                      @deleteAllocatedFranchisee="deleteAllocatedFrachisee"
                      @swapAllocatedFranchisee="dragDropSwapFrachisee"
                    />
                  </div>
                </div>
              </v-col>
              <v-col v-show="amsListView" cols="12" md="2" lg="2" sm="2">
                <v-card elevation="0">
                  <v-card-subtitle class="pl-0"
                    >Unallocated Center</v-card-subtitle
                  >
                  <draggable
                    class="list-group custom-cursor"
                    :data-type="'unallocated'"
                    :list="unallocatedFranchisee"
                    group="amSlot"
                    :move="moveUnallocatedFranchisee"
                    @end="onDragEnd"
                    :style="'height:' + dayLength * 40 + 'px;'"
                  >
                    <div
                      v-for="(item, index) in unallocatedFranchisee"
                      :key="item.id + '_unallocatedFranchisee_' + index"
                      :data-itemobj="JSON.stringify(item)"
                    >
                      <v-badge
                        class="mt-2"
                        left
                        :color="item.color"
                        :content="item.priority"
                        overlap
                      >
                        <v-list-item class="red lighten-3 mb-1 white--text">
                          <v-list-item-content>
                            <v-list-item-title>{{
                              item.companyName
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-badge>
                    </div>
                  </draggable>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Utils from '@/utils'
import constants from '@/utils/constants'
import draggable from 'vuedraggable'
import draganddrop from '@/components/AcademicManager/dragdrop'
import amscalenderview from '@/components/AcademicManager/amsCalenderView'
export default {
  name: 'amsCenterAllocation',
  components: {
    draganddrop,
    draggable,
    amscalenderview
  },
  props: ['selectedZoneId'],
  data () {
    return {
      tab: null,
      zoneId: '',
      zoneArray: [],
      zonalManager: '',
      allocated: 0,
      unAllocated: 0,
      dayLength: 0,
      highPriorityCount: 0,
      mediumPriorityCount: 0,
      lowPriorityCount: 0,
      franchiseeList: [],
      selectedFranchisee: [],
      academicManger: [],
      copyAcademicManager: [],
      unallocatedFranchisee: [],
      fromIndex: 0,
      toIndex: 0,
      amsArray: [],
      selectedAms: '',
      amsListView: true,
      singleBtnToggle: 0,
      zoneAcademicCalendar: ''
    }
  },
  watch: {
    singleBtnToggle: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.amsListView = !this.amsListView
      }
    }
  },
  computed: {
    isAllocateVisits: function () {
      return this.checkModuleAccess('allocationAccess')
    }
  },
  created: async function () {
    await this.getZoneData()
    this.tab = this.selectedZoneId
    await this.getZoneDetails(parseInt(this.selectedZoneId))
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    filterAcademicData: function (type) {
      if (type === 'searchCenter') {
        if (this.selectedFranchisee.length > 0) {
          this.copyAcademicManager = this.academicManger
          let filteredArray = []
          this.academicManger.forEach((item) => {
            let innerFilter = []
            this.selectedFranchisee.forEach((franchisee) => {
              item.allocatedFranchisees.forEach((obj) => {
                if (obj.franchiseeID === franchisee.id) {
                  innerFilter.push(obj)
                }
              })
            })
            // innerFilter = item.allocatedFranchisees.filter(obj => {
            //   return
            // })
            if (innerFilter.length > 0) {
              let itemObj = {}
              itemObj.amID = item.amID
              itemObj.amName = item.amName
              itemObj.allocatedFranchisees = innerFilter
              filteredArray.push(itemObj)
            }
          })
          this.academicManger = filteredArray
        }
      } else {
        this.selectedFranchisee = []
        if (typeof this.selectedAms === 'object' && this.selectedAms !== null) {
          this.copyAcademicManager = this.academicManger
          let filteredArray = this.academicManger.filter((item) => {
            return this.selectedAms.id === item.amID
          })
          this.academicManger = filteredArray
        }
      }
    },
    resetSearchData: function (type) {
      if (type === 'searchCenter') {
        this.selectedAms = ''
      } else {
        this.selectedFranchisee = []
      }
      this.academicManger =
        this.copyAcademicManager.length > 0
          ? this.copyAcademicManager
          : this.academicManger
      this.copyAcademicManager = []
    },
    getZoneData: async function () {
      try {
        const res = await http.get(`${constants.API_URL}/api/ams/get-zones`)
        if (res.status === 200) {
          this.zoneArray = res.data
        } else {
          this.errMsg(res.data.message)
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getZoneDetails: async function (zoneId) {
      try {
        this.zoneAcademicCalendar = ''
        this.zoneId = zoneId
        this.resetZoneTab()
        const res = await http.get(
          `${constants.API_URL}/api/get/academic-manager-visit-allocation-details/${zoneId}`
        )
        if (res.status === 200) {
          this.zonalManager = res.data.zonalManagerName
          this.dayLength = res.data.workingDays
          this.allocated = res.data.zoneAllocatedFranchiseeCount
          this.unAllocated = res.data.zoneUnallocatedFranchiseeCount
          // this.dayLength = 10
          this.highPriorityCount = res.data.high
          this.mediumPriorityCount = res.data.medium
          this.lowPriorityCount = res.data.low
          this.franchiseeList = res.data.franchiseeList
          this.zoneAcademicCalendar = res.data.zoneAcademicCalendar
          this.franchiseeList.forEach((item) => {
            if (!item.allocated) {
              if (item.priority === 1) {
                item.priority = 'H'
                item.color = 'deep-orange darken-3'
              } else if (item.priority === 2) {
                item.priority = 'M'
                item.color = 'orange darken-3'
              } else {
                item.priority = 'L'
                item.color = 'green darken-2'
              }
              this.unallocatedFranchisee.push(item)
            }
          })
          this.academicManger = res.data.academicManagers
          this.academicManger.forEach((item) => {
            this.amsArray.push({ id: item.amID, name: item.amName })
          })
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    resetZoneTab: function () {
      this.zonalManager = ''
      this.dayLength = 0
      this.highPriorityCount = 0
      this.mediumPriorityCount = 0
      this.lowPriorityCount = 0
      this.franchiseeList = []
      this.unallocatedFranchisee = []
      this.academicManger = []
      this.amsArray = []
      this.selectedAms = ''
    },
    moveUnallocatedFranchisee: function (evt) {
      this.unallocatedObj = {}
      if (evt.from.dataset.type !== evt.to.dataset.type) {
        let unallocatedObj = {}
        this.fromIndex = evt.draggedContext.index
        this.toIndex = evt.to.dataset.index
        unallocatedObj.amId = evt.to.dataset.amid
        unallocatedObj.franchiseeID = evt.draggedContext.element.id
        unallocatedObj.companyName = evt.draggedContext.element.companyName
        unallocatedObj.priority = evt.draggedContext.element.priority
        unallocatedObj.visits = evt.draggedContext.element.visits
        this.unallocatedObj = unallocatedObj
      }
    },
    onDragEnd: async function (evt) {
      if (!this.isAllocateVisits) {
        return this.errMsg(
          'You are not authorize to allocate an unallocated center.'
        )
      }
      if (this.academicManger.length === 0) {
        return this.errMsg('Please asign AM to particular zone.')
      }
      if (evt.from.dataset.type === evt.to.dataset.type) {
        return false
      }
      if (
        !this.unallocatedObj ||
        Object.keys(this.unallocatedObj).length === 0
      ) {
        this.academicManger[this.toIndex].allocatedFranchisees.splice(
          evt.newIndex,
          1
        )
        return false
      }
      if (!evt.originalEvent.defaultPrevented) {
        let franchiseeObj = JSON.parse(evt.clone.dataset.itemobj)
        this.academicManger[this.toIndex].allocatedFranchisees.splice(
          evt.newIndex,
          1
        )
        this.unallocatedFranchisee.splice(this.fromIndex, 0, franchiseeObj)
        return false
      }
      let slotLength = 0
      this.academicManger[this.toIndex].allocatedFranchisees.forEach((item) => {
        slotLength += item.visits
      })
      if (slotLength <= this.dayLength) {
        try {
          this.unallocatedFranchisee.splice(this.fromIndex, 1)
          let payload = {}
          payload.amID = parseInt(this.unallocatedObj.amId)
          payload.franchiseeID = this.unallocatedObj.franchiseeID
          payload.zoneID = this.zoneId
          const res = await http.post(
            `${constants.API_URL}/api/ams/allocate-franchisee-to-am`,
            payload
          )
          if (res.status === 200) {
            this.getZoneDetails(this.zoneId)
            this.okMsg(res.data)
          } else {
            this.errMsg(res.data.message)
          }
        } catch (e) {
          let franchiseeObj = JSON.parse(evt.clone.dataset.itemobj)
          this.academicManger[this.toIndex].allocatedFranchisees.splice(
            evt.newIndex,
            1
          )
          this.unallocatedFranchisee.splice(this.fromIndex, 0, franchiseeObj)
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          this.errMsg(errorMessage)
        }
      } else {
        let franchiseeObj = JSON.parse(evt.clone.dataset.itemobj)
        this.academicManger[this.toIndex].allocatedFranchisees.splice(
          evt.newIndex,
          1
        )
        this.unallocatedFranchisee.splice(this.fromIndex, 0, franchiseeObj)
        // this.academicManger[this.toIndex].allocatedFranchisees.splice(evt.newIndex, 1)
        this.errMsg('No more slot assign this AM. ')
      }
    },
    dragDropSwapFrachisee: async function (data) {
      let slotLength = 0
      let futureIndex = data.futureIndex
      this.academicManger[data.toIndex].allocatedFranchisees.forEach((item) => {
        slotLength += item.visits
      })
      if (slotLength <= this.dayLength) {
        try {
          let payload = {}
          payload.amFranchiseeMapID = data.franchiseObj.amFranchiseeMapID
          payload.amID = parseInt(data.amId)
          payload.franchiseeID = data.franchiseObj.franchiseeID
          payload.zoneID = this.zoneId
          const res = await http.post(
            `${constants.API_URL}/api/ams/swap-am-franchisee-allocation`,
            payload
          )
          if (res.status === 200) {
            this.getZoneDetails(this.zoneId)
            this.okMsg(res.data)
          } else {
            this.errMsg(res.data.message)
          }
        } catch (e) {
          this.academicManger[data.toIndex].allocatedFranchisees.splice(
            futureIndex,
            1
          )
          this.academicManger[data.fromIndex].allocatedFranchisees.splice(
            data.fromElementIndex,
            0,
            data.franchiseObj
          )
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          this.errMsg(errorMessage)
        }
      } else {
        this.academicManger[data.toIndex].allocatedFranchisees.splice(
          futureIndex,
          1
        )
        this.academicManger[data.fromIndex].allocatedFranchisees.splice(
          data.fromElementIndex,
          0,
          data.franchiseObj
        )
        this.errMsg('No more slot assign this AM.')
      }
    },
    deleteAllocatedFrachisee: async function (data) {
      try {
        let dataObj = data
        const res = await http.get(
          `${constants.API_URL}/api/get/unallocate-franchisee-mapping/${data.franchiseeMapId}`
        )
        if (res.status === 200) {
          this.academicManger[dataObj.parentIndex].allocatedFranchisees.splice(
            dataObj.childIndex,
            1
          )
          this.getZoneDetails(this.zoneId)
          this.okMsg(res.data)
        } else {
          this.errMsg(res.data.message)
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    okMsg: function (msg) {
      return this.$dialog.notify.info(msg, {
        position: 'top-right',
        color: 'success',
        timeout: 4000
      })
    },
    errMsg: function (msg) {
      return this.$dialog.notify.info(msg, {
        position: 'top-right',
        color: 'error',
        timeout: 4000
      })
    }
  }
}
</script>
<style>
.custom-table-layout {
  width: 100%;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
  border: solid 1px #000;
  overflow-x: scroll;
}
.days-column {
  width: 50px;
  height: auto;
  overflow: hidden;
  border-right: solid 1px #000;
  display: table-cell;
  position: sticky !important;
  left: 0px;
  z-index: 2;
}
.days-text {
  width: 100%;
  margin: 0 auto;
  height: 40px;
  font-size: 13px;
  border-bottom: solid 1px #000;
  text-align: left;
  position: sticky !important;
  left: 0px;
  background: #fff;
}
.days-header {
  width: 100%;
  margin: 0 auto;
  height: 40px;
  font-size: 12px;
  border-bottom: solid 1px #3949ab;
  background: #3949ab;
  color: #fff;
}
.custom-list-item {
  position: relative;
  overflow: hidden;
  height: auto;
  width: 100%;
}
.am-column {
  min-width: 150px;
  height: 100%;
  overflow: hidden;
  display: table-cell;
  border-right: solid 1px #000;
}
.am-header {
  width: 100%;
  margin: 0 auto;
  height: 40px;
  font-size: 12px;
  border-bottom: solid 1px #3949ab;
  background: #3949ab;
  color: #fff;
}
.am-text {
  height: 40px;
  margin: 0 auto;
  text-align: left;
  font-size: 13px;
}
.am-text:hover {
  cursor: all-scroll;
}
.custom-cursor:hover {
  cursor: all-scroll;
}
.text-field-row {
  width: 100%;
  margin: 0 auto;
  height: auto;
  overflow: hidden;
}
.custom-list-item:hover {
  border: solid 1px #e4e4e4;
  /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
}
div.custom-chip {
  width: 140px;
  height: 44px;
  overflow: hidden;
  border-radius: 20px !important;
  justify-content: left;
  vertical-align: middle;
  padding-top: 2px;
  float: left;
}
.unallocated-border {
  height: auto;
  border-radius: 19px;
  padding: 1px 0px 2px 0px;
  border: solid 2px #ef9a9a;
}
.allocated-border {
  height: auto;
  border-radius: 19px;
  padding: 1px 0px 2px 0px;
  border: solid 2px #89a82b;
}
.custom-avatar {
  height: 35px;
  width: 35px;
  justify-content: center;
  vertical-align: middle;
  overflow: hidden;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  color: #fff;
}
.custom-position {
  position: absolute;
  right: 1px;
  top: -2px;
  cursor: pointer;
  display: none;
}
.custom-list-item:hover > .custom-position {
  display: block;
}
.custom-list-item:hover > .custom-position > button:hover {
  color: #212121;
}
</style>
